'use client';
import { useRef } from 'react';

const useHeightOfElement = function (ref) {
  let {
    initialHeightForSsr
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const elementHeightRef = useRef(initialHeightForSsr ?? 0);
  if (ref.current) {
    elementHeightRef.current = ref.current.offsetHeight;
  }
  return elementHeightRef.current;
};

export { useHeightOfElement as default };
